import { Component } from '@angular/core';

@Component({
  selector: 'app-more-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './more-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class MoreIconComponent {}
